/**
 * The filename a `Content-Disposition` header suggests (TMMAPP-0005): the RFC 5987 `filename*=`
 * form wins when present (percent-decoded), else the quoted / bare `filename=` form. `null` when
 * the header is absent or carries neither.
 */
export function filenameFromContentDisposition(header: string | undefined): string | null {
  if (!header) return null;
  const extended = /filename\*\s*=\s*(?:UTF-8|utf-8)?''([^;]+)/.exec(header);
  if (extended?.[1]) {
    try {
      const decoded = decodeURIComponent(extended[1].trim());
      if (decoded.length > 0) return decoded;
    } catch {
      // A malformed percent-encoding falls through to the plain form.
    }
  }
  const quoted = /filename\s*=\s*"((?:[^"\\]|\\.)*)"/.exec(header);
  if (quoted?.[1] !== undefined) {
    const unescaped = quoted[1].replace(/\\(.)/g, '$1');
    return unescaped.length > 0 ? unescaped : null;
  }
  const bare = /filename\s*=\s*([^;]+)/.exec(header);
  if (bare?.[1]) {
    const value = bare[1].trim();
    return value.length > 0 ? value : null;
  }
  return null;
}
